export const cases = [
  {
    id: 'c001',
    client: '鲜果园',
    category: '品牌策划',
    title: '新消费水果品牌从0到1的品牌升级',
    description: '为鲜果园完成品牌定位重塑、视觉体系升级与年度传播策略，品牌认知度提升320%。',
    metric: '品牌认知度提升 320%',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fresh%20fruit%20brand%20packaging%20design%20on%20minimal%20white%20surface%2C%20vibrant%20colorful%20fruits%20with%20modern%20packaging%20boxes%2C%20professional%20product%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20background%2C%20clean%20editorial%20style%20with%20subtle%20green%20and%20amber%20tones&width=600&height=400&seq=case-c001&orientation=landscape',
  },
  {
    id: 'c002',
    client: '云智科技',
    category: '视频制作',
    title: 'B2B科技企业品牌宣传片制作',
    description: '为云智科技打造企业品牌宣传片，从脚本创意到后期制作全流程服务，全网播放量突破500万。',
    metric: '全网播放量 500万+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20tech%20company%20office%20with%20futuristic%20LED%20screens%20showing%20data%20visualization%2C%20professional%20corporate%20environment%2C%20warm%20ambient%20lighting%20mixing%20with%20cool%20tech%20glow%2C%20editorial%20corporate%20photography%20style%2C%20clean%20minimal%20space%20with%20warm%20neutral%20tones&width=600&height=400&seq=case-c002&orientation=landscape',
  },
  {
    id: 'c003',
    client: '锦绣家居',
    category: '社交媒体',
    title: '家居品牌小红书全域种草 campaign',
    description: '为锦绣家居策划执行小红书全域种草 campaign，3个月内实现品牌词搜索量增长800%。',
    metric: '搜索量增长 800%',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20home%20interior%20design%20scene%2C%20scandinavian%20living%20room%20with%20warm%20wood%20furniture%20and%20natural%20plants%2C%20soft%20natural%20light%20from%20large%20windows%2C%20lifestyle%20editorial%20photography%20style%2C%20cozy%20warm%20neutral%20color%20palette%20with%20subtle%20green%20accents&width=600&height=400&seq=case-c003&orientation=landscape',
  },
  {
    id: 'c004',
    client: '悦享美妆',
    category: '数字营销',
    title: '美妆品牌抖音直播月销破千万',
    description: '为悦享美妆搭建抖音直播运营体系，通过达人矩阵+自播双轮驱动，月均GMV突破1200万。',
    metric: '月均 GMV 1200万+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20beauty%20products%20arrangement%20on%20marble%20surface%2C%20elegant%20skincare%20bottles%20and%20cosmetics%20with%20soft%20natural%20lighting%2C%20premium%20beauty%20brand%20photography%20style%2C%20warm%20neutral%20tones%20with%20rose%20gold%20and%20cream%20accents%2C%20high%20detail%20editorial%20composition&width=600&height=400&seq=case-c004&orientation=landscape',
  },
  {
    id: 'c005',
    client: '山野咖啡',
    category: '创意设计',
    title: '精品咖啡品牌全案视觉设计',
    description: '为山野咖啡打造从品牌命名到VI系统的完整视觉体系，品牌门店数量一年内从3家扩张至25家。',
    metric: '门店扩张至 25 家',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artisan%20coffee%20shop%20interior%20with%20warm%20wood%20counter%20and%20latte%20art%20coffee%20cups%2C%20cozy%20minimalist%20cafe%20atmosphere%2C%20soft%20morning%20light%2C%20lifestyle%20editorial%20photography%20style%2C%20warm%20earthy%20neutral%20tones%20with%20subtle%20green%20plant%20accents&width=600&height=400&seq=case-c005&orientation=landscape',
  },
  {
    id: 'c006',
    client: '启航教育',
    category: '品牌策划',
    title: '在线教育品牌年度传播 campaign',
    description: '为启航教育策划年度传播 campaign，整合短视频、直播、私域三大阵地，线索获取成本降低60%。',
    metric: '线索成本降低 60%',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20online%20learning%20scene%20with%20student%20using%20tablet%20at%20bright%20minimal%20desk%2C%20warm%20natural%20light%2C%20educational%20content%20on%20screen%2C%20professional%20lifestyle%20editorial%20photography%2C%20warm%20neutral%20tones%20with%20subtle%20green%20accents%2C%20clean%20and%20focused%20atmosphere&width=600&height=400&seq=case-c006&orientation=landscape',
  },
] as const;